import { clsx } from 'clsx';
import { CSSProperties } from 'react';
import styles from './CircleSpinner.module.scss';

interface Props {
  className?: string;
  style?: CSSProperties;
  size?: 'extrasmall' | 'small' | 'medium' | 'large' | 'extralarge' | 'huge';
  dataTestId?: string;
}

const CircleSpinner: React.FC<Props> = ({ className, size = 'medium', dataTestId, style }) => {
  return (
    <span
      role="progressbar"
      aria-busy="true"
      className={clsx(styles.loader, className)}
      style={style}
      data-size={size}
      data-testid={dataTestId}
    />
  );
};

export default CircleSpinner;
